import { render, staticRenderFns } from "./CommissionQuotaAttainment.vue?vue&type=template&id=47bd4224&"
import script from "./CommissionQuotaAttainment.vue?vue&type=script&lang=ts&"
export * from "./CommissionQuotaAttainment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports